module.exports = __webpack_public_path__ + "static/img/category-commission-campaigns-banner.f41cb33e.png";